module.exports = __webpack_public_path__ + "media/images/diy/testimonial_caleb-509824a094ed5276515cbd65e669e613.jpg";